import api from './api';

export interface TimesheetEntry {
  id?: string;
  date: string; // ISO date string
  hours: number;
  projectDescription: string;
  clientId: string;
  clientName?: string;
  isBillable?: boolean; // Defaults to true for backward compatibility
  category?: string; // Category for non-billable time
}

export interface Timesheet {
  id: string;
  userId: string;
  entries: TimesheetEntry[];
  startDate: string;
  endDate: string;
  status: 'draft' | 'submitted' | 'approved' | 'invoiced';
  createdAt: string;
  updatedAt: string;
}

export interface CreateTimesheetData {
  entries: TimesheetEntry[];
  startDate: string;
  endDate: string;
  status?: 'draft' | 'submitted' | 'approved' | 'invoiced';
}

export interface UpdateTimesheetData extends Partial<CreateTimesheetData> {}

export interface TimesheetFilters {
  startDate?: string;
  endDate?: string;
  status?: 'draft' | 'submitted' | 'approved' | 'invoiced';
}

export interface FloodFillData {
  clientId: string;
  startDate: string;
  endDate: string;
  hours: number;
  projectDescription: string;
  isBillable?: boolean;
  category?: string;
}

export const timesheetsApi = {
  getAll: async (filters?: TimesheetFilters): Promise<Timesheet[]> => {
    const params = new URLSearchParams();
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    if (filters?.status) params.append('status', filters.status);
    
    const queryString = params.toString();
    const url = `/timesheets${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getById: async (id: string): Promise<Timesheet> => {
    const response = await api.get(`/timesheets/${id}`);
    return response.data.data;
  },

  create: async (data: CreateTimesheetData): Promise<Timesheet> => {
    const response = await api.post('/timesheets', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateTimesheetData): Promise<Timesheet> => {
    const response = await api.put(`/timesheets/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/timesheets/${id}`);
  },

  floodFill: async (data: FloodFillData): Promise<TimesheetEntry[]> => {
    const response = await api.post('/timesheets/flood-fill', data);
    return response.data.data;
  },
};
